import React from "react";
import Context from "../../../Context";
import { Dropdown } from "react-bootstrap";

const DropdownToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span
    title="Меню версий"
    ref={ref}
    className={`cursor-pointer text-light text-hover-primary`}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));

export default class ManualVersions extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      versions: [],
      current: {},
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    let prevItem = prevProps.item || {};
    let item = this.props.item || {};
    if (
      prevItem.id !== item.id ||
      prevProps.currentVersion !== this.props.currentVersion
    ) {
      this.load();
    }
  }

  load = async () => {
    const { item = {} } = this.props;
    this.setState({ pending: true });
    let versions = [];
    let current = {};
    if (item.id) {
      /*   versions = await this.context.api.qa(`/manual/content/list`, {
        filter: { manual: item.id },
        orderby: ["validfromdate DESC"],
      });*/

      versions = this.props.versions;

      if (Array.isArray(versions)) {
        if (this.props.currentVersion) {
          current =
            versions.find(
              (version) => version.id === this.props.currentVersion
            ) || {};
        } else {
          current =
            versions.find(
              (version) => version.version === this.props.item.version
            ) || {};
        }
      }
    }
    this.setState({ pending: false, versions: versions || [], current });
  };
  render() {
    const { item = {} } = this.props;
    const { current = {}, pending } = this.state;

    if (!item.id) return null;
    if (pending) {
      return (
        <div className="d-inline-flex">
          <div className="spinner-border text-muted spinner-border-sm"></div>
        </div>
      );
    }

    let currentdate = current.validfromdate
      ? new Date(current.validfromdate)
      : {};
    return (
      <>
        <div className="d-inline-flex">
          <div className="font-italic text-muted">
            {current.version} от {currentdate.toLocaleString()}
          </div>
          <Dropdown>
            <Dropdown.Toggle as={DropdownToggle} id="dropdown-actions">
              <i className="fa fa-ellipsis-v ml-2 "></i>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {this.state.versions.map((version) => {
                let date = version.validfromdate
                  ? new Date(version.validfromdate)
                  : {};
                return (
                  <div
                    key={version.id}
                    onClick={() => this.props.onVersionChange(version)}
                    className="dropdown-item text-center cursor-pointer"
                  >
                    {current.id === version.id && (
                      <i className="fa fa-check mr-2 text-primary"></i>
                    )}
                    {date.toLocaleString()}
                    <span className="small text-muted ml-2">
                      {version.version}
                    </span>{" "}
                  </div>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </>
    );
  }
}
